import { Box, Paper, Title, Text, Button, Flex, Container, Anchor, PasswordInput } from "@mantine/core";
import { IconLock, IconArrowLeft } from "@tabler/icons-react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import trpc from "../../shared/utils/trpc";
import { successNotification } from "../../shared/utils/successNotification";
import { handleTrpcError } from "../../shared/utils/trpc/handletrpcError.util";

function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // Validation
  const passwordError = password && password.length < 8 ? "Password must be at least 8 characters" : null;
  const confirmPasswordError = confirmPassword && password !== confirmPassword ? "Passwords do not match" : null;

  const isFormValid = password.length >= 8 && password === confirmPassword;

  const handleSubmit = async () => {
    if (!isFormValid) return;

    setLoading(true);
    try {
      await trpc.auth.confirmPasswordReset.mutate({
        token,
        newPassword: password,
      });

      successNotification({
        title: "Password Reset Successful",
        message: "Your password has been reset. You can now login.",
      });

      navigate("/login");
    } catch (err) {
      handleTrpcError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box mih="100vh" py={40}>
      <Container size="lg">
        <Flex direction="column" align="center" gap={4} mb="xl">
          <img src="/gtLogo.svg" alt="GTsetu" style={{ height: 100, width: "auto", marginBottom: 4 }} />
        </Flex>

        <Paper
          shadow="sm"
          p={{ base: "lg", sm: "xl" }}
          radius="lg"
          maw={550}
          mx="auto"
          style={{ border: "1px solid #E5E7EB" }}
        >
          <Title order={2} fz={{ base: 20, sm: 24 }} mb="xs">
            Reset Password
          </Title>

          <Text fz="sm" c="slate.6" mb="xl">
            Enter your new password below.
          </Text>

          <PasswordInput
            label={
              <Text fz="sm" fw={500} mb={4}>
                Password{" "}
                <Text span c="red">
                  *
                </Text>
              </Text>
            }
            placeholder="Create a strong password"
            value={password}
            onChange={(e) => setPassword(e.currentTarget.value)}
            leftSection={<IconLock size={18} color="#9CA3AF" />}
            error={passwordError}
            mb="md"
            styles={{
              input: {
                borderColor: "#E5E7EB",
                "&:focus": {
                  borderColor: "#2563EB",
                },
              },
            }}
          />

          <PasswordInput
            label={
              <Text fz="sm" fw={500} mb={4}>
                Confirm Password{" "}
                <Text span c="red">
                  *
                </Text>
              </Text>
            }
            placeholder="Re-enter password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.currentTarget.value)}
            leftSection={<IconLock size={18} color="#9CA3AF" />}
            error={confirmPasswordError}
            mb="xl"
            styles={{
              input: {
                borderColor: "#E5E7EB",
                "&:focus": {
                  borderColor: "#2563EB",
                },
              },
            }}
          />

          <Button fullWidth size="md" onClick={handleSubmit} loading={loading} disabled={!isFormValid || loading}>
            Reset Password
          </Button>

          <Flex justify="center" mt="lg">
            <Anchor component={Link} to="/login" size="sm" c="#2563EB">
              <Flex align="center" gap={4}>
                <IconArrowLeft size={14} />
                Back to Login
              </Flex>
            </Anchor>
          </Flex>
        </Paper>
      </Container>
    </Box>
  );
}

export default ResetPasswordPage;
